import React from 'react'
import ModalV5 from "../../../../ui/modal/v5/v5"
import ModalV5_Header from "../../../../ui/modal/v5/header/header"
import FieldFormElement from "../../../../../core/fields3/render/form-elemnent"
import FormModel from "../../../../../core/gd-form/common/form-model-manager"
import FormFlex from "../../../../../core/gd-form/form/form-flex/form"
import FormRowFlex from "../../../../../core/gd-form/form/form-flex/row"
import ButtonSubmit from "../../../../../core/gd-form/common/btn-submit/btn-submit-ui5-new"
import Webhook from "../../../../../core/model2/webhook/webhook-v2/webhook"
import WebhookFields from "../../../../../core/model2/webhook/webhook-v2/fields"
import ApiAutomationsWebhooks from "../../../../../core/gd/api/automations-webhooks"
import generateWebhookSecret from "../../../../../core/model2/webhook/webhook-v2/generate-secret"

type Props = {
    webhook?    : Webhook
    onSaved?    : callback     // (webhook) => void  — receives the saved model
}

export default class ModalWebhook extends React.Component<Props> {

    private model  : Webhook
    private fields : WebhookFields = new WebhookFields()
    public  form   : FormModel

    constructor(props: Props) {
        super(props)

        // A new webhook opens with a ready-made secret - the user can keep it,
        // copy it, or type their own over it.
        this.model = props.webhook
            ? props.webhook.clone()
            : new Webhook({secret: generateWebhookSecret()})

        // onFormChanged fires once, on the first edited value - that is all Save
        // needs to come alive. ButtonSubmit re-renders itself on that event, but
        // with the props it already has, so the modal has to redraw for the
        // disabled flag below to be recomputed.
        this.form = new FormModel(this.model, {
            onSubmit      : this.onSubmit,
            onFormChanged : () => this.forceUpdate(),
        })
    }

    get isEdit(): boolean {
        return !!this.props.webhook
    }

    // The secret is owned by the client and travels with both create and
    // update. An empty one is left out on purpose: `secret: ''` would blank the
    // stored value on update, and on create the server would generate one
    // behind our back.
    private buildPayload(): any {

        const payload: any = {
            name        : this.model.name,
            endpointUrl : this.model.endpointUrl,
        }

        if (this.model.secret) {
            payload.secret = this.model.secret
        }

        return payload
    }

    onSubmit = async () => {
        try {
            const payload = this.buildPayload()

            const response = this.isEdit
                ? await ApiAutomationsWebhooks.update(this.props.webhook!.id, payload).promise()
                : await ApiAutomationsWebhooks.create(payload).promise()

            // Update does not echo the secret back, so the client's copy stands
            // in for it; create does, and then the response wins.
            const saved = new Webhook({secret: this.model.secret, ...response})

            gd.modal.hide()

            this.props.onSaved?.(saved)

        } catch (e) {
            // onSubmitClick flipped the button to "busy" and only ever flips it
            // back here - without this a failed save leaves it stuck
            this.form.resetSubmit()
            gd.apiError(e)
        }
    }

    get headerTitle(): string {
        return this.isEdit ? 'Edit webhook' : 'New webhook'
    }


    render() {

        return (
            <ModalV5 className="w-600">

                <ModalV5_Header title={this.headerTitle}/>

                <div className="p-t-20 p-b-30">
                    <FormFlex className="m-l-30 m-r-30">

                        <FormRowFlex width={120} form={this.form} field={this.fields.name} label="Name">
                            <FieldFormElement className = "w-400"
                                              field     = {this.fields.name}
                                              form      = {this.form}
                                              model     = {this.model}/>
                        </FormRowFlex>

                        <FormRowFlex width={120} form={this.form} field={this.fields.endpointUrl} label="Endpoint URL">
                            <FieldFormElement className = "w-400"
                                              field     = {this.fields.endpointUrl}
                                              form      = {this.form}
                                              model     = {this.model}/>
                        </FormRowFlex>

                        <FormRowFlex width       = {120}
                                     form        = {this.form}
                                     field       = {this.fields.secret}
                                     label       = "Secret">
                            {/* fl-sb pushes the Copy button the field draws
                                inside itself onto the right edge */}
                            <FieldFormElement className = "w-400 fl-sb"
                                              field     = {this.fields.secret}
                                              form      = {this.form}
                                              model     = {this.model}/>
                        </FormRowFlex>

                        <div className="flex-row-center-center m-t-30">
                            {/* Dead until something is actually edited - on
                                create too, so an untouched form cannot be
                                submitted at all. */}
                            <ButtonSubmit className = "submit w-140"
                                          form      = {this.form}
                                          disabled  = {!this.form.isFormChanged}
                                          label     = {this.isEdit ? 'Save' : 'Create'}/>
                        </div>

                    </FormFlex>
                </div>

            </ModalV5>
        )
    }
}
